export const formatResponse = response => {
  const formattedData = response.data.data.map(item => ({
    ...item,
    location: item?.city && item?.stateSlug ? `${item?.city}, ${item?.stateSlug}` : ''
  }));

  return { ...response, data: { ...response.data, data: formattedData } };
};
